export {
  default,
  StyledInput,
  StyledPlaceholder,
  StyledValue,
} from './EditableField';
